"use strict";
import _classes from "./shared.module.css.js";
const sharedClasses = {
  listItem: _classes["list-item"],
  listItemDestructive: _classes["list-item-destructive"],
  navigationItem: _classes["navigation-item"]
};
export {
  sharedClasses
};
